<ejs-dialog #dialog
            [isModal]="true"
            [ngClass]="{'hide-footer': !modalDialog?.showFooter, 'darkened-modal': modalDialog?.isDarkened}"
            cssClass="modal-sm"
            [showCloseIcon]="true"
            [visible]="false"
            (beforeClose)="onClose($event)">
  <ng-template #header>
    {{modalDialog?.title | translate}}
  </ng-template>

  <ng-template #content>
    <div [innerHTML]="modalDialog?.message | translate">
    </div>
  </ng-template>

  <ng-template #footerTemplate>
    @if (modalDialog?.showFooter) {
      <button class="btn btn-secondary me-2" (click)="cancelClicked()">{{'i18n.shared.cancel' | translate}}</button>
      <button class="btn btn-danger" (click)="okClicked()">{{'i18n.shared.ok' | translate}}</button>
    }
  </ng-template>
</ejs-dialog>
